import { create } from 'zustand'

import { getUsers, getClByUserCode, getClDetails, saveUserProfile, updateUserAdmin } from './provider'

import type { UserUsersProps } from './types'

export const useUsers = create<UserUsersProps>((set) => ({
  usersData: null,
  setUsersData: (data) => set({ usersData: data }),

  isUsersLoading: false,
  setIsUsersLoading: (value) => set({ isUsersLoading: value }),

  clByUserCodeData: null,
  setClByUserCodeData: (data) => set({ clByUserCodeData: data }),

  isClByUserCodeLoading: false,
  setIsClByUserCodeLoading: (value) => set({ isClByUserCodeLoading: value }),

  clDetailsData: null,
  setClDetailsData: (data) => set({ clDetailsData: data }),

  isClDetailsLoading: false,
  setIsClDetailsLoading: (value) => set({ isClDetailsLoading: value }),

  isSaveUserProfileLoading: false,
  setIsSaveUserProfileLoading: (value) => set({ isSaveUserProfileLoading: value }),

  isUpdateUserAdminLoading: false,
  setIsUpdateUserAdminLoading: (value) => set({ isUpdateUserAdminLoading: value }),

  getUsers,
  getClByUserCode,
  getClDetails,
  saveUserProfile,
  updateUserAdmin
}))
